<template>
  <div>
    <el-form ref="form" class="exr-type-form" label-width="80px">
      <el-form-item label="等级">
        <el-select v-model="level" filterable placeholder="等级">
          <el-option
            v-for="item in $store.state.levels"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内部标题">
        <el-input v-model="name"></el-input>
      </el-form-item>
      <el-form-item label="展示标题">
        <el-input v-model="title"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input type="textarea" v-model="description" resize="none" autosize></el-input>
      </el-form-item>
      <el-form-item label="倒计时">
        <el-input v-model="countdown" placeholder="输入以秒为单位的整数"></el-input>
      </el-form-item>
      <el-form-item label="模板">
        <el-radio-group v-model="template" class="exr-type-list">
          <el-radio border label="xzt">选择题(xzt)</el-radio>
          <el-radio border label="dct">对错题(dct)</el-radio>
          <el-radio border label="xctk">选词填空(xctk)</el-radio>
          <el-radio border label="xktc">选空填词(xktc)</el-radio>
          <el-radio border label="pxt">排序题(pxt)</el-radio>
          <el-radio border label="lyt">录音题(lyt)</el-radio>
          <el-radio border label="xsd">选声调(xsd)</el-radio>
          <el-radio border label="dwtk">短文填空(dwtk)</el-radio>
          <el-radio border label="zct">找错题(zct)</el-radio>
          <el-radio border label="pdt">配对题(pdt)</el-radio>
          <el-radio border label="dht">对话题(dht)</el-radio>
          <el-radio border label="hdwt">AI回答问题(hdwt)</el-radio>
          <el-radio border label="ktsh">AI看图说话(ktsh)</el-radio>
        </el-radio-group>
      </el-form-item>
      <component :is="templateComponent" ref="config"></component>
    </el-form>
  </div>
</template>

<script>
import exrxzt from './types/xzt.vue'
import exrdct from './types/dct.vue'
import exrxctk from './types/xctk.vue'
import exrxktc from './types/xktc.vue'
import exrpxt from './types/pxt.vue'
import exrlyt from './types/lyt.vue'
import exrxsd from './types/xsd.vue'
import exrdwtk from './types/dwtk.vue'
import exrpdt from './types/pdt.vue'
import exrzct from './types/zct.vue'
import exrdht from './types/dht.vue'

export default {
  name: 'type-form',
  components: { exrxzt, exrdct, exrxctk, exrxktc, exrpxt, exrlyt, exrxsd, exrdwtk, exrpdt, exrzct, exrdht },
  data () {
    return {
      id: null,
      level: null,
      name: '',
      title: '',
      description: '',
      template: 'xzt',
      countdown: null,
      status: 1
    }
  },
  methods: {
    reset (item) {
      item = Object.assign({
        id: null,
        level: null,
        name: '',
        title: '',
        description: '',
        template: 'xzt',
        countdown: null,
        status: 1
      }, item)
      this.id = item.id
      this.level = item.level
      this.name = item.name
      this.title = item.title
      this.description = item.description
      this.status = item.status
      this.template = item.template
      this.countdown = item.countdown
      if (item.data_json) {
        window.setTimeout(() => {
          this.$refs.config.config = {translatable: {}, ...JSON.parse(item.data_json)}
        }, 1)
      }
    },
    submit () {
      var params = {
        level: this.level,
        name: this.name,
        title: this.title,
        description: this.description,
        inspection: 1,
        template: this.template,
        status: this.status,
        countdown: this.countdown,
        data: {...this.$refs.config.config}
      }
      const translatable = params.data.translatable;
      const keys = Object.keys(translatable).filter(k => translatable[k]);
      if (keys.length) {
        params.data.translatable = keys.reduce((pv, cv) => {
          pv[cv] = translatable[cv];
          return pv;
        }, {});
      } else {
        delete params.data.translatable;
      }
      if (this.id) {
        return this.$http.put(this.$urls.exercise_type_update, params, {
          params: { id: this.id }
        })
      } else {
        return this.$http.post(this.$urls.exercise_type_create, params).then(data => {
          this.id = data.id
        })
      }
    }
  },
  computed: {
    templateComponent: function () {
      return 'exr' + this.template
    }
  }
}
</script>
<style lang="scss">
  .exr-type-list {
    display: flex;
    flex-wrap: wrap;
    padding-right: 30px;
    margin-bottom: -12px;
    > label{
      margin-bottom: 12px;
      margin-right: 0 !important;
      margin-left: 0 !important;
      width: 25%;
      &:nth-child(4n+2){
        transform: translateX(10px);
      }
      &:nth-child(4n+3){
        transform: translateX(20px);
      }
      &:nth-child(4n+4){
        transform: translateX(30px);
      }
    }
  }
  .exr-type-subject{
    .el-form-item__content{
      margin-bottom: -5px;
      display: flex;
      flex-wrap: wrap;
      > *{
        margin-bottom: 5px;
        margin-right: 5px;
        margin-left: 0 !important;
      }
    }
  }
  .exr-type-form {
    .el-form-item{
      margin-bottom: 15px;
    }
    .el-checkbox{
      &.is-bordered{
        margin-right: 0;
      }
    }
  }
</style>
